/**
 * Pure heuristics for guessing a TT order's type from its free-text fields.
 * Extracted (unchanged behavior) from the original
 * RiskManagementFullDashboard/BrokerageDashboard/tt/transform.ts so it can be
 * unit tested and reused by both v1 and v2 pages.
 */

export type GuessedOrderType = "hta" | "pricing" | "position_adjust" | null;

export interface OrderTextFields {
  textA?: string | null;
  textB?: string | null;
  textC?: string | null;
  textTT?: string | null;
}

function textContainsHta(fields: Array<string | null | undefined>): boolean {
  return fields.some((f) => /hta/i.test(f ?? ""));
}

function textContainsPricing(fields: Array<string | null | undefined>): boolean {
  return fields.some((f) => /pricing/i.test(f ?? ""));
}

function textContainsAdj(fields: Array<string | null | undefined>): boolean {
  return fields.some((f) => /pos/i.test(f ?? "") && /adj/i.test(f ?? ""));
}

/**
 * Guess order type from text fields using regex patterns.
 * Priority: HTA > Pricing > Position Adjust > null
 */
export function getSuggestedOrderType(fields: OrderTextFields | null | undefined): GuessedOrderType {
  if (!fields) return null;
  const arr = [fields.textA, fields.textB, fields.textC, fields.textTT];
  if (textContainsHta(arr)) return "hta";
  if (textContainsPricing(arr)) return "pricing";
  if (textContainsAdj(arr)) return "position_adjust";
  return null;
}
